<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_planet_building')
}

const isOnPlanetsSection = computed(() => {
  return route.path.startsWith('/planets')
})

const goToPlanets = () => {
  router.push('/planets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/planet.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.planetBuilding.backbone') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.planetBuilding.construct') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.planetBuilding.requireProduction" tag="span">
          <template #productionIcon><GenericIcon type="production" /></template>
        </i18n-t>
      </p>
      <p class="pb-2">
        {{ t('tutorial.planetBuilding.startBuilding') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="mb-2">
        <p class="pb-2">
          <i18n-t keypath="tutorial.planetBuilding.clickProduction" tag="span">
            <template #productionIcon><GenericIcon type="production" /></template>
          </i18n-t>
        </p>
        <i18n-t keypath="tutorial.planetBuilding.clickAgain" tag="span">
          <template #productionIcon><GenericIcon type="production" /></template>
        </i18n-t>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnPlanetsSection" @click="goToPlanets" class="mr-2">
        {{ t('tutorial.planetBuilding.gotoPlanets') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.planetBuilding.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>